import { useQuery } from "@grandvisionhq/graphql";
import { GET_PREFERRED_STORE_ID } from "../../../../operations/queries/operations/queries/get-preferred-store-id.js";
const useGetPreferredStoreId = (onError) => {
  const query = useQuery(GET_PREFERRED_STORE_ID, {
    onError(error) {
      onError?.(error, "stores.storeDetailsRoot.preferredStoreFetch.error");
    }
  });
  return {
    data: query.data?.me?.preferredStore ?? null,
    loading: query.loading,
    error: query.error
  };
};
export {
  useGetPreferredStoreId as default
};
//# sourceMappingURL=use-get-preferred-store-id.js.map
